export const getCatalogs = state => state.catalogsReducer
